<div #videoBox class="hidden" style="line-height: 0em; border-radius: 12px; position: fixed; top: 10px; left: 10px; z-index: 9999999999;">
	<video #videoPlayer style="border-radius: 12px;" muted=true autoplay=true type="video/mp4" width=400 height=300>
		<!-- <source src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" type="video/mp4"> -->
		<span>{{'Video is not supported' | translate}}</span>
	</video>
</div>
<div class="split-container" [ngStyle]="isZooming ? {'pointer-events':'none'} : null">
<!-- <div class="split-container" [ngStyle]="{'pointer-events': 'none'}" > -->
	<as-split direction="horizontal" class="views" [useTransition]="true">
		<as-split-area *ngFor="let view of views; let k = index; trackById" class="view"  [ngClass]="{'highlight': (selectedMapIdx === k && views.length) > 1,'not-highlight':(selectedMapIdx !== k)}">
			<a [id]="'split-view-anchor-button-' + k" class="btn btn-sm btn-circle split-view-anchor-button" [class.disabled]="disableChangeMap && selectedMapIdx !== k" [ngClass]="(selectedMapIdx === k)?'btn-primary':'btn-light'" *ngIf="views.length > 1" (click)="onSelectMap(k)">{{'Click to make this active layer' | translate}}</a>
			<div class="map" [id]="'map-container-' + k" [style.left]="getViewOffset(k)">
				<div class="curtain">
					<img [style.marginLeft]="getViewOffset(k, true)" src="assets/images/grid.svg">
				</div>	
			</div>
		</as-split-area>
	</as-split>
</div>
<div id="container">
	<canvas id="c"></canvas>
	<div id="labels"></div>
	<div id="referenced-cards">
		<div *ngFor="let card of mapService.referenceCards; let k = index; trackById" [id]="'referenced-card-' + k" class="referenced-card" [style.backgroundImage]="'url(' + card.bgUrl + ')'" (mouseover)="lastCardOverId = k">
			<div class="rc-toolbar" [ngClass]="{ 'over' : lastCardOverId == k }">
				<span class="icon-arrow-top-right"></span><span>View</span>
			</div>
		</div>
	</div>
</div>
<!-- <div class="action-btns">
	<button (click)="onClickAdd()" [disabled]="_maps.length >= MAX_MAP_VIEW_COUNT">Add</button>
	<button (click)="onClickRemove()" [disabled]="_maps.length == 1">Remove</button>
	<button (click)="onClickUnsync()" [disabled]="_maps.length <= 1">UnSync</button>
	<button (click)="onClickResync()" [disabled]="_maps.length <= 1">ReSync</button>
</div> -->
